var localScroll = {
  init() {
    /**
     * Scroll to main content link
     */
    $('.scroll-to-main').on('click', function (e) {
      e.preventDefault();

      $('html,body').stop().animate({
        scrollTop: $('main.main').offset().top - 150,
      }, 500, 'swing');
    });


    $('.btn-get-in-touch').on('click', function (e) {
      e.preventDefault();

      $('html,body').stop().animate({
        scrollTop: $('#get-in-touch').offset().top - 150,
      }, 500, 'swing');
    });
  },
};

export default localScroll;



// WEBPACK FOOTER //
// ./scripts/modules/local-scroll.js